import { BasePayloadMapper } from '@ps/utils';

import { CreateTemplateFolderRequestDto } from '../dtos/template.dto';

export interface CreateTemplateFolderPayload {
  name: string;
  hasImpersonatedBuyer: boolean;
  parentFolderId?: number;
}

export class TemplateFolderPayloadMapper extends BasePayloadMapper<
  CreateTemplateFolderPayload,
  CreateTemplateFolderRequestDto
> {
  public toPayload({
    name,
    hasImpersonatedBuyer,
    parentFolderId,
  }: CreateTemplateFolderPayload): CreateTemplateFolderRequestDto {
    const payload: CreateTemplateFolderRequestDto = {
      name,
      is_service_buyer: hasImpersonatedBuyer,
    };

    if (parentFolderId) {
      payload.parent_folder = parentFolderId;
    }

    return payload;
  }
}
